import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { injectContentsquareScript } from '@contentsquare/tag-sdk';
import { HotJarSessionService } from './hot-jar-session.service';

@Injectable({
  providedIn: 'root',
})
export class HotJarService {
  isEnabled = environment.hotJar.enabled;

  constructor(private hotJarSessionService: HotJarSessionService) {}

  public init(): void {
    if (this.isEnabled) {
      injectContentsquareScript({
        siteId: environment.hotJar.siteId,
        async: true,
        defer: false,
      });
    }
  }

  public tryTriggerRecord(): void {
    if (this.isEnabled && this.hotJarSessionService.isSessionValidForRecording()) {
      this.waitForHotjarReady(() => {
        (window as any).hj('event', 'session_start');
      });
    }
  }

  private waitForHotjarReady(callback: () => void, maxWaitMs = 10000): void {
    const start = Date.now();
    const check = (): void => {
      if ((window as any).hj) {
        callback();
        return;
      }

      if (Date.now() - start >= maxWaitMs) {
        return;
      }

      setTimeout(check, 200);
    };

    check();
  }
}
